var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4682 6.28732C17.9084 5.75551 17.8342 4.96755 17.3024 4.52735C16.7706 4.08715 15.9826 4.16141 15.5424 4.69322L8.94553 12.6629L5.53379 9.25116C5.04563 8.763 4.25417 8.763 3.76602 9.25116C3.27786 9.73931 3.27786 10.5308 3.76602 11.0189L8.14345 15.3964C8.50653 15.7594 9.03741 15.8525 9.48647 15.6754C9.68211 15.6012 9.86175 15.4767 10.0047 15.304L17.4682 6.28732Z",
    fill: "#3482FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.58f0003d60bffd83ccaf98c551de5da5.svg";
export { ForwardRef as ReactComponent };